<template>
  <div class="content-wrapper" id="articleAdd">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">文章內容</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">話題</li>
              <li class="breadcrumb-item">
                <a href="../../topic/article.html">文章列表</a>
              </li>
              <li class="breadcrumb-item active">文章內容</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <el-form
                  :model="articleModel"
                  ref="articleModel"
                  :rules="articlerules"
                >
                  <el-form-item
                    label="文章封面（建議尺寸: 1280*720）"
                    prop="sgL_ImageId"
                  >
                    <div class="image-thumbnail w-25">
                      <el-upload
                        class="upload-demo"
                        :action="uploadurl + '&id=' + this.user.userId"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :on-remove="handleRemove"
                        :limit="1"
                        :file-list="fileList"
                        list-type="picture"
                      >
                        <el-button size="small" type="primary"
                          >點擊上傳</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                          只支援jpg/png格式，且不超過5M
                        </div>
                      </el-upload>
                      <img
                        v-if="imageUrl"
                        :src="imageUrl"
                        style="width: 305px"
                      />
                      <!-- <el-upload
                          class="upload-demo"
                          :action="imageurl+'&id='+this.user.userId"
                          drag
                          :show-file-list="false"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">点击上传</div>
                          <div class="el-upload__tip">支持绝大多数图片格式，单张图片最大支持5MB</div>
                      </el-upload>-->
                    </div>
                  </el-form-item>
                  <el-form-item label="文章標題" prop="sgL_Title">
                    <el-input
                      v-model="articleModel.sgL_Title"
                      placeholder="請輸入標題"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="文章類型" prop="sgL_MasterSort">
                    <el-select
                      v-model="articleModel.sgL_MasterSort"
                      placeholder="請選擇類型"
                    >
                      <el-option
                        v-for="(type) in articleTypeList"
                        v-bind:key="type.id"
                        :label="type.sgL_NewName"
                        :value="type.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="文章內容" prop="sgL_Content" >
                    <Editor v-model="articleModel.sgL_Content" />
                  </el-form-item>
                  <el-form-item label="轉載來源">
                    <el-select
                      v-model="articleModel.sgL_ReprintedSourceId"
                      placeholder="請選擇轉載來源"
                    >
                      <el-option :value="0" label="請選擇"></el-option>
                      <el-option
                        v-for="reprint in rePrintList"
                        v-bind:key="reprint.id"
                        :label="reprint.sgL_Title"
                        :value="reprint.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="關鍵字（以 ',' 作分隔，不需加上空格）">
                    <el-input
                      v-model="articleModel.sgL_NKeyword"
                      placeholder="e.g. 賽事報導,路跑,渣打馬拉松"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公開狀態" prop="sgL_NStatus">
                    <el-select v-model="articleModel.sgL_NStatus">
                      <el-option label="顯示" :value="true"></el-option>
                      <el-option label="隱藏" :value="false"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="排序">
                    <el-input-number
                      v-model="articleModel.sgL_OrderBy"
                    ></el-input-number>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button
                      @click="submitArticle('articleModel')"
                      type="primary"
                      class="float-right"
                      >保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <el-dialog
          title="图片剪裁"
          :visible.sync="dialogVisible"
          append-to-body
        >
          <div class="cropper-content">
            <div class="cropper" style="text-align: center">
              <vueCropper
                ref="cropper"
                :img="option.img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :centerBox="option.centerBox"
                :infoTrue="option.infoTrue"
                :fixedBox="option.fixedBox"
              ></vueCropper>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="finish" :loading="loading"
              >确认</el-button
            >
          </div>
        </el-dialog>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import base from "../../api/httpApi/base";
// import { VueCropper } from "vue-cropper";
import Editor from "../common/Editor";
import { Message } from "element-ui";
export default {
  data() {
    return {
      imageUrl: "",
      Id: null,
      fileList: [],
      uploadurl: `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=topic`,
      rePrintList: [],
      articleTypeList: [],
      articleModel: {
        id: "",
        sgL_OrderBy: 0,
        sgL_MasterSort: null,
        sgL_NKeyword: "",
        sgL_UserId: 0,
        sgL_NStatus: true,
        sgL_Title: "",
        sgL_Content: "",
        sgL_ImageId: null,
        sgL_ReprintedSourceId: 0,
      },
      articlerules: {
        sgL_Title: [
          { required: true, message: "請輸入影片標題", trigger: "blur" },
        ],
        sgL_ImageId: [
          {
            required: true,
            message: "請輸入影片標題",
          },
        ],
        sgL_Content: {
          required: true,
          message: "請輸入内容",
          trigger: "blur",
        },
        sgL_MasterSort: {
          required: true,
          message: "請選擇類型",
          trigger: "change",
        },
        sgL_NStatus: {
          required: true,
          message: "請選擇狀態",
          trigger: "change",
        },
      },
      user: {}, //上传视频时需要带上用户id
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [], //页面显示的数组
      // 防止重复提交
      loading: false,
    };
  },
  created() {
    let id = this.$route.query.Id;
    if (id != null && id != "") {
      this.Id = id;
      this.getArticle(id);
    }
    this.getArticleType();
    this.GetReprintList();
    this.user = this.$store.getters.getUser;
    //获取所有文章类型
  },
  components: {
    // VueCropper,
    Editor,
  },
  methods: {
    getArticle(id) {
      let params = {
        Id: id,
      };
      this.$api.TopicApi.GetArticle(params).then((res) => {
        if (res.data.success) {
          this.articleModel = res.data.result;
          this.imageUrl = this.articleModel.sgL_ImageUrl;
        }
      });
    },
    getArticleType() {
      let params = {
        SGL_TypeT: 10, //文章類型
      };
      this.$api.TopicApi.GetArticleType(params).then((res) => {
        if (res.data.success) {
          this.articleTypeList = res.data.result.items;
        }
      });
    },
    //获取所有的转载来源
    GetReprintList() {
      this.$api.TopicApi.GetReprintList().then((res) => {
        if (res.data.success) {
          this.rePrintList = res.data.result.items;
        }
      });
    },

    //获取所有转载来源

    submitArticle(formName) {
      if (this.articleModel.sgL_ImageId == null) {
        Message({
          type: "error",
          message: "請上傳封面圖片",
        });
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            // sgL_OrderBy: this.articleModel.sgL_OrderBy,
            sgL_ImageId: this.articleModel.sgL_ImageId, //圖片id
            sgL_Content: this.articleModel.sgL_Content,
            sgL_Title: this.articleModel.sgL_Title, //title
            sgL_UserId: this.user.userId,
            sgL_ReprintedSourceId: this.articleModel.sgL_ReprintedSourceId, //轉載
            sgL_NStatus: this.articleModel.sgL_NStatus, //狀態
            sgL_NKeyword: this.articleModel.sgL_NKeyword,
            sgL_MasterSort: this.articleModel.sgL_MasterSort, //文章類型
          };
          if (this.articleModel.id == "") {
            //添加
            this.$api.TopicApi.Addarticle(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "添加成功",
                });
                this.$router.push({ name: "TopicList" });
              }
            });
          } else {
            //修改
            params.id = this.Id;
            this.$api.TopicApi.Updatearticle(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
                this.$router.push({ name: "TopicList" });
              }
            });
          }
        }
      });
    },
    // 上传按钮   限制图片大小
    changeUpload(file, fileList) {
      let _this = this;
      let formData = new FormData();
      // 输出
      if (file.type === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          let img = window.URL.createObjectURL(data);
          this.model = true;
          this.modelSrc = img;
          formData.append("file", data, this.fileName);
          this.$http
            .post(Api.uploadSysHeadImg.url, formData, {
              contentType: false,
              processData: false,
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            })
            .then((response) => {
              var res = response.data;
              if (res.success == 1) {
                $("#btn1").val("");
                _this.imgFile = "";
                _this.headImg = res.realPathList[0]; //完整路径
                _this.uploadImgRelaPath = res.relaPathList[0]; //非完整路径
                _this.$message({
                  //element-ui的消息Message消息提示组件
                  type: "success",
                  message: "上传成功",
                });
              }
            });
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true;
          this.modelSrc = data;
        });
      }
      //   const isLt5M = file.size / 1024 / 1024 < 5;
      //   if (!isLt5M) {
      //     this.$message.error("上传文件大小不能超过 5MB!");
      //     return false;
      //   }
      //   this.fileinfo = file;

      //   // 上传成功后将图片地址赋值给裁剪框显示图片
      //   this.$nextTick(() => {
      //     this.option.img = file.url;
      //     this.dialogVisible = true;
      //   });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        var fileName = "goods" + this.fileinfo.uid;
        this.loading = true;
        //上传阿里云服务器
        client()
          .put(fileName, data)
          .then((result) => {
            this.dialogVisible = false;
            this.picsList.push(result.url);
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      });
    },
    //#region 上传图片
    handleAvatarSuccess(res, file) {
      this.articleModel.sgL_ImageId = res.result.uploadId;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !ispng) {
        this.$message.error("上传封面图片只能是 JPG /png格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return (ispng || isJPG) && isLt5M;
    },
    handleRemove() {
      this.imageUrl = "";
    },
    //#endregion
  },
};
</script>
<style>
.el-form-item__label[for*='sgL_Content']{
 float: none;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTopic/articleAdd.vue